import mapGraphqlDayNumberToString from 'mapGraphqlDayNumberToString';

import { toTermName } from './rangeTerms';

export interface BreakdownRow {
  // As the chart names the row's part: a day of the week, a date, or a
  // dimension A term (a range's "from - to")
  name: string;
  value: number;
}

// A single metric's rows, each named as the pie, donut, funnel, pyramid and
// tree map charts name their parts: by day of the week, by date, or by
// dimension A term. None for a chart grouped by none of them. In the rows'
// order: the charts sort them as they draw them.
const toBreakdownRows = ({
  data,
  chartDef,
}: {
  data: V5ChartData;
  chartDef: V5ChartDefinition;
}): BreakdownRow[] => {
  const first = Object.values(data)[0];
  if (!first) {
    return [];
  }
  const { metric, response } = first;
  const toName = ((): ((row: MetricResponse) => string) | undefined => {
    if (chartDef.groupByDayOfWeek) {
      return (row) => mapGraphqlDayNumberToString(row['dayOfWeek'] as string);
    }
    if (chartDef.trendByCalendarInterval || chartDef.trendByFixedIntervalDays) {
      return (row) => row['date'] as string;
    }
    if (chartDef.dimensionA) {
      return (row) => toTermName({ chartDef, row });
    }
    return undefined;
  })();
  if (!toName) {
    return [];
  }
  return response.map((row) => ({
    name: toName(row),
    value: row[metric.id] as number,
  }));
};

export default toBreakdownRows;
